<template>
  <router-view />
</template>

<script>
export default {
  name: 'NotesIndex'
}
</script>
